import { initSubRoutes } from '../../../../utils/router';

const RoutesSupprimerArme = initSubRoutes({
    route: '/supprimer',
    subroutes: {},
    nom: 'Supprimer une/des armes',
});

export default RoutesSupprimerArme;
